const doc = [({"zh_tw":({"adminConstantListTypes":({"planList":"按方案列表查看", "roomList":"按房型列表查看"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;